import React from "react";
import styled from "styled-components";
import { PALETTE } from "../../styles/palette";
import { Children, PrecipitationType, Sky, Weather } from "../../types";
import { Header } from "../header";

const StyledLayout = styled.div<{ backgroundColor: string }>`
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.backgroundColor};
  padding: 4px 16px 0;
`;

const StyledMain = styled.main`
  width: 100%;
`;

type LayoutHeaderProps = {
  children: Children;
  location: string;
  todayWeather: Weather;
};

export const LayoutHeader = ({
  children,
  location,
  todayWeather,
}: LayoutHeaderProps) => {
  const getBackgroundColor = (
    sky: Sky,
    precipitationType: PrecipitationType
  ): string => {
    if (precipitationType === "소나기") return PALETTE.DARK_BLUE;
    switch (sky) {
      case "맑음":
        return PALETTE.YELLOW;
      case "구름많음":
        return PALETTE.LIGHT_GRAY;
      case "흐림":
        return PALETTE.GRAY;
      default:
        return PALETTE.WHITE;
    }
  };

  return (
    <StyledLayout
      backgroundColor={getBackgroundColor(
        todayWeather.sky,
        todayWeather.precipitationType
      )}
    >
      <Header location={location} />
      <StyledMain>{children}</StyledMain>
    </StyledLayout>
  );
};
